import { Button, Col, Form, Input, Row, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser, updateUser } from "../../actions/users";
import { useNavigate } from "react-router-dom";

const EditCurrentUser = () => {
  const currentUser = JSON.parse(localStorage.getItem("profile"));
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const user = useSelector((state) => state.users);
  const history = useNavigate();

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    dispatch(getUser(currentUser.id));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onFinish = (formData) => {
    setLoadingButton(true);
    dispatch(updateUser(currentUser.id, formData, history, setLoadingButton));
  };

  useEffect(() => {
    form.setFieldsValue({
      name: user?.name,
      email: user?.email,
      phone: user?.phone,
    });
  }, [user]);

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      requiredMark={false}
      form={form}
      autoComplete="off"
    >
      <div className="mb-4">
        <div className="p-2">
          <Skeleton loading={loading}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please input user name!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please input user email!" },
                  ]}
                >
                  <Input type="email" disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[
                    { required: true, message: "Please input user phone!" },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <div className="flex flex-wrap justify-start gap-4">
                  <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                    {() => (
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loadingButton}
                      >
                        Update
                      </Button>
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Skeleton>
        </div>
      </div>
    </Form>
  );
};

export default EditCurrentUser;
